export const Endpoint = process.env.REACT_APP_ENDPOINT
  ? process.env.REACT_APP_ENDPOINT
  : 'http://wgorder-service.new.welcome-group.ru'
